import axiosInstance from '../../../config/axios';

export interface WorkAreaAttachmentRule {
  work_area_id: number;
  default_selected: boolean;
  order: number;
}

export interface WorkAreaAttachmentResponse {
  id: number;
  name?: string;
  default_selected: boolean;
  order: number;
}

export interface WorkAreaAttachmentsPayload {
  rules: WorkAreaAttachmentRule[];
}

export interface WorkAreaOption {
  id: number;
  name: string;
}

export async function getWorkAreaAttachments(templateCode: string): Promise<WorkAreaAttachmentRule[]> {
  const { data } = await axiosInstance.get<{ work_areas: WorkAreaAttachmentResponse[] }>(
    `/api/admin/templates/${templateCode}/work-area-attachments/`
  );
  const workAreas = data.work_areas || [];
  return workAreas.map(wa => ({
    work_area_id: wa.id,
    default_selected: wa.default_selected,
    order: wa.order,
  }));
}

export async function updateWorkAreaAttachments(
  templateCode: string,
  payload: WorkAreaAttachmentsPayload
): Promise<void> {
  await axiosInstance.put(
    `/api/admin/templates/${templateCode}/work-area-attachments/`,
    payload
  );
}

export async function listWorkAreas(): Promise<WorkAreaOption[]> {
  const { data } = await axiosInstance.get<WorkAreaOption[]>('/api/admin/work-areas/');
  return data;
}
